var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 error_page_container"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }